// extracted by mini-css-extract-plugin
export default {"fabButton":"AttachmentsModal_fabButton__ve6KY"};